import { Component, OnInit, Input, Output, EventEmitter, Inject } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { CustomerEntity } from '../../../../models/entities/customer';
import { ActivatedRoute } from '@angular/router';
import { CUSTOMER_ENTITY_SERVICE_TOKEN, REQUISITION_ENTITY_SERVICE_TOKEN } from '../../../../injection-tokens/entity-service-tokens';
import { IRequisitionEntityService } from '../../../../interfaces/entities/requisition-entity-service-interface';
import { IShortLogger, Log } from '../../../../services/logger.service';
import { RequisitionPreviewViewComponent } from '../requisition-preview-view/requisition-preview-view.component';
import { AdditionalInformationData } from '../../../../models/wizard-plugin-models/additional-information-data';
import { BillingDetailsData } from '../../../../models/wizard-plugin-models/billing-details-data';
import { CustomerDetails } from '../../../../models/entities/requisition-model';
import { ErrorHandlerService } from '../../../../decoration-base/error-handler.service';
import { ICustomerEntityService } from '../../../../interfaces/entities/customer-entity-service.interface';
import { RequisitionData } from '../../../../models/wizard-plugin-models/requisition-data';
import { TrainingScheduleData, TrainingSchedulesData } from '../../../../models/wizard-plugin-models/training-schedules-data';
import { LoginEntityService } from '../../../../services/entity-services/login-entity.service';
import { TrainerEntity } from '../../../../models/entities/trainer';
import { NotificationService } from '../../../../services/notification.service';

// interface Customer {
//   id: string;
//   name: string;
//   gstNumber: string;
//   contactPerson: {
//     name: string;
//     mobile: string;
//     email: string;
//   };
//   address: string;
//   customerType: string;
// }


interface TrainingSchedule_Data {
  Id: string;
  Title: string;
  DateRanges: DateRange[];
  Participants: string[];
  Trainers: Trainer[];
  Course?: Course;
  ResourceType?: string;
  ResourceDetails?: any;
  RemovalOption: 'immediate' | 'scheduled' | 'manual' | 'None';
  RemovalDateTime?: Date;
  TrainersRemarks?: string;
  TrainingDetail?: string;
  ResourceTemplateIds?: ResourceTemplate[];
  AccessViaInvitedEmailOnly: Boolean;
}


interface DateRange {
  Id?: string;
  Title: string;
  StartDate: Date;
  EndDate: Date;
  StartTime: string;
  EndTime: string;
}

interface Course {
  Id: string;
  Name: string;
  Code: string;
  Provider: string;
  description?: string;
  duration?: string;
  vmImage?: any;
  labs?: any[];
  showMenu?: boolean;
  isActive?: boolean;
  createdBy?: string;
  createdOn?: string;
  updatedOn?: string;
  updatedBy?: string;
  entityType?: string;
}

interface Trainer {
  Id: string;
  Name: string;
}

interface ResourceTemplate {
  id: string;
  name: string;
}

@Component({
  selector: 'app-requisition-edit',
  templateUrl: './requisition-edit.component.html',
  styleUrl: './requisition-edit.component.css'
})


export class RequisitionEditComponent implements OnInit {
  openAddCustomerModal() {
    throw new Error('Method not implemented.');
  }

  public requisitionData: RequisitionData = new RequisitionData();
  public billingDetailsData: BillingDetailsData | null = null;
  public trainingSchedulesData: TrainingSchedule_Data[] = [];//new TrainingSchedulesData();
  public additionalInformationData: AdditionalInformationData | null = null;

  @Input() requisitionId: string = '';
  @Output() closePopup = new EventEmitter<void>();
  @Output() saved = new EventEmitter<RequisitionData>();

  requisitionForm!: FormGroup;
  currentStep: number = 1;

  // Customer options
  customers: any[] = [];
  customerTypes = [
    { type: 'Corporate' },
    { type: 'Individual' },
    { type: 'Educational Institution' },
    { type: 'Government' }
  ];

  // Training options
  trainers: TrainerEntity[] = [];
  courseOptions: any[] = [];

  // Calendar related
  activeTabIndex: number = 0;
  currentMonth: Date = new Date();
  dayHeaders = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  // Date selection
  // isSelecting = false;
  // selectionStart: Date | null = null;
  // tempDateRange: Date[] = [];
  showTimeModal = false;
  tempStartTime = '09:00';
  tempEndTime = '17:00';
  tempTitle = '';
  timeSelectionForm!: FormGroup;

  docDateString: string = '';
  // public requisitionId: string = '';



  // Add these properties after existing properties
  private tabCalendarStates: {
    [tabIndex: number]: {
      currentDate: Date;
      calendarDates: { date: Date, isCurrentMonth: boolean }[];
      dateRanges: DateRange[];
      isPanelOpen: boolean;
      isSelecting: boolean;
      selectionStart: Date | null;
      selectionEnd: Date | null;
      currentHoverDate: Date | null;
    }
  } = {};

  editingRange: DateRange | null = null;
  editingTabIndex: number = 0;
  isSelecting = false;
  selectionStart: Date | null = null;
  tempDateRange: { start: Date, end: Date } | null = null;


  private readonly logger: IShortLogger<RequisitionEditComponent> = Log.create(RequisitionEditComponent);

  constructor(private fb: FormBuilder,

    @Inject(REQUISITION_ENTITY_SERVICE_TOKEN) public requisitionService: IRequisitionEntityService,

    private route: ActivatedRoute,
    @Inject(CUSTOMER_ENTITY_SERVICE_TOKEN) private customerService: ICustomerEntityService,
    private errorHandler: ErrorHandlerService, private loginEntityService: LoginEntityService,
    private notification: NotificationService
  ) { }

  ngOnInit1(): void {
    this.initializeForm();
    this.createForm();
    this.loadCourse();
    this.loadCustomers();
    this.userGetByRole('trainer');
    // Initialize calendar state for first tab
    this.initializeTabCalendarState(0);
    this.setupMouseEvents();
    // this.requisitionId = this.route.snapshot.paramMap.get('id')! || '';
    if (this.requisitionId) {
      this.loadRequisitionData();
    }
  }

  userGetByRole(role: string): void {

    this.loginEntityService.userGetByRole(role).subscribe({
      next: (result) => {
        this.trainers = result;
        this.logger.i('Loaded Trainer:', this.trainers);
      },
      error: (err) => {
        this.logger.e('Error loading users:', err);
      }
    });
  }

  async loadCustomers(): Promise<void> {
    this.errorHandler.tryExecuteAsync(async () => {
      this.customers = await this.customerService.getAllCustomers();
    }, 'loadCustomers');
    this.logger.i('Loaded customers:', this.customers);
  }

  oldRequisitionData: any = null;

  private loadRequisitionData(): void {
    this.requisitionService.getRequisitionById(this.requisitionId).subscribe((res: any) => {

      this.oldRequisitionData = res;
      this.logger.d('OLD :: Requisition data loaded:', res.data);
      this.requisitionData = res.data.RequisitionData;
      this.billingDetailsData = res.data.BillingDetailsData;
      this.trainingSchedulesData = res.data.TrainingSchedulesData;
      this.additionalInformationData = res.data.AdditionalInformationData;

      this.logger.i("training schedule data :: res.data.TrainingSchedulesData", res.data.TrainingSchedulesData, 'data:', res.data);
      this.logger.i("requisition data :: ", this.requisitionData);
      this.logger.i("billing details data :: ", this.billingDetailsData);
      this.logger.i("additional information data :: ", this.additionalInformationData);
      // this.initializeForm();
      this.populateForm(this.requisitionData);
      this.populateFormTrainingScheduleData(this.trainingSchedulesData);
      this.populateFormAdditionalInfo(this.additionalInformationData);
    });
  }



  private createForm() {
    this.requisitionForm = this.fb.group({
      requisition: this.fb.group({
        enquiryId: [''],
        docNo: [{ value: '', disabled: true }, Validators.required],
        docDate: ['', Validators.required],
        status: ['Draft', Validators.required]
      }),
      customerDetails: this.fb.group({
        customerId: ['', Validators.required],
        customerGstNumber: [{ value: '', disabled: true }, Validators.required],
        customerType: [{ value: 'Corporate', disabled: true }, Validators.required],
        contactPersonName: [{ value: '', disabled: true }, Validators.required],
        contactPersonNumber: [{ value: '', disabled: true }, Validators.required],
        contactPersonEmail: [{ value: '', disabled: true }, [Validators.required, Validators.email]],
        customerAddress: [{ value: '', disabled: true }, Validators.required],
      }),
      trainingSchedules: this.fb.array([this.createScheduleGroup()]),
      additionalInfo: this.fb.group({
        specialRequirements: [''],
        finalComments: [''],
      })
    });
  }

  initializeForm(): void {
    this.requisitionForm = this.fb.group({
      enquiryId: [''],
      docNo: [{ value: '', disabled: true }],
      docDate: [new Date()],
      customerDetails: this.fb.group({
        id: ['', Validators.required],
        customerType: ['Corporate'],
        name: [''],
        gstNumber: [''],
        contactPerson: this.fb.group({
          name: [''],
          mobile: [''],
          email: ['']
        }),
        address: ['']
      }),
      trainingSchedules: this.fb.array([]),
      specialRequirements: [''],
      finalComments: ['']
    });

    this.timeSelectionForm = this.fb.group({
      startTime: ['09:00'],
      endTime: ['17:00'],
      trainingTitle: ['']
    });

    // Add at least one training schedule
    this.addSchedule();
  }

  loadCourse(): void {

    // Load courses
    this.courseOptions = [{ id: '-1', name: 'Custom Course' }
    ];
  }

  populateForm(data: RequisitionData | null): void {

    this.requisitionForm.get('requisition')?.patchValue({
      enquiryId: data?.enquiryId,
      docNo: data?.docNo,
      docDate: data?.docDate,
    });

    const customerId = data?.customerDetails?.id;
    const customer = this.customers.find(c => c.id === customerId);
    if (customer) {
      this.logger.d('Selected customer:', customer);
      this.requisitionForm.get('customerDetails')?.patchValue({
        // name: customer.name,
        customerType: customer.customerType || 'Corporate',
        customerId: customer.id,
        customerGstNumber: customer.gstNumber,
        contactPersonName: customer.contactPerson.name,
        contactPersonNumber: customer.contactPerson.mobile,
        contactPersonEmail: customer.contactPerson.email,
        customerAddress: customer.address
      });
    }

    this.docDateString = data ? this.formatDateForInput(data.docDate) : '';

    // Clear existing schedules and add from data
    const schedulesArray = this.requisitionForm.get('trainingSchedules') as FormArray;
    schedulesArray.clear();

    // data.trainingSchedules.forEach(schedule => {
    //   const scheduleGroup = this.createScheduleGroup();
    //   scheduleGroup.patchValue(schedule);
    //   schedulesArray.push(scheduleGroup);
    // });
  }


  populateFormTrainingScheduleData1(data: TrainingSchedule_Data[]): void {
    const schedulesArray = this.requisitionForm.get('trainingSchedules') as FormArray;
    schedulesArray.clear();
    this.logger.d('populateFormTrainingScheduleData : data:: ', data);
    if (!data || data.length === 0) {
      this.logger.w('No trainingSchedulesData found');
      return;
    }
    data.forEach(schedule => {
      const dateRangesArray = this.fb.array(
        (schedule.DateRanges || []).map(range =>
          this.fb.group({
            id: [range.Id],
            startDate: [new Date(range.StartDate)],
            endDate: [new Date(range.EndDate)],
            startTime: [range.StartTime],
            endTime: [range.EndTime],
            //  title: [range.Title]
          })
        )
      );

      const scheduleGroup = this.fb.group({
        title: [schedule.Title || ''],
        courseId: [schedule.Course?.Id || ''],
        participants: [schedule.Participants || []],
        accessViaInvitedEmailOnly: [schedule.AccessViaInvitedEmailOnly || false],
        trainers: [schedule.Trainers[0].Id || ''],
        trainingDetail: [schedule.TrainingDetail || ''],
        dateRanges: dateRangesArray,
        isPanelOpen: [false]
      });

      schedulesArray.push(scheduleGroup);
    });
  }


  populateFormAdditionalInfo(data: AdditionalInformationData | null): void {

    this.requisitionForm.get('additionalInfo')?.patchValue({
      specialRequirements: data?.specialRequirements,
      finalComments: data?.finalComments
    });

  }

  formatDateForInput(date: Date): string {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  get schedules(): FormArray {
    return this.requisitionForm.get('trainingSchedules') as FormArray;
  }

  createScheduleGroup(): FormGroup {
    return this.fb.group({
      title: [''],
      courseId: [''],
      participants: [[]],
      accessViaInvitedEmailOnly: [false],
      trainers: [''],
      trainingDetail: [''],
      dateRanges: [[]],
      isPanelOpen: [false]
    });
  }

  addSchedule1(): void {
    this.schedules.push(this.createScheduleGroup());
    this.activeTabIndex = this.schedules.length - 1;
  }

  removeCurrentSchedule(): void {
    if (this.schedules.length > 1) {
      this.schedules.removeAt(this.activeTabIndex);
      this.activeTabIndex = Math.max(0, this.activeTabIndex - 1);
    }
  }

  setActiveTab1(index: number): void {
    this.activeTabIndex = index;
  }

  // Calendar Methods
  getCurrentTabCalendarDates1(): any[] {
    const dates = [];
    const year = this.currentMonth.getFullYear();
    const month = this.currentMonth.getMonth();

    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const prevLastDay = new Date(year, month, 0);

    const startingDayOfWeek = firstDay.getDay();
    const endingDayOfWeek = lastDay.getDay();

    // Previous month days
    for (let i = startingDayOfWeek - 1; i >= 0; i--) {
      const date = new Date(year, month, -i);
      dates.push({ date, isCurrentMonth: false });
    }

    // Current month days
    for (let i = 1; i <= lastDay.getDate(); i++) {
      const date = new Date(year, month, i);
      dates.push({ date, isCurrentMonth: true });
    }

    // Next month days
    const remainingDays = 6 - endingDayOfWeek;
    for (let i = 1; i <= remainingDays; i++) {
      const date = new Date(year, month + 1, i);
      dates.push({ date, isCurrentMonth: false });
    }

    return dates;
  }

  getMonthYear1(): string {
    return this.currentMonth.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
  }

  previousMonth1(): void {
    this.currentMonth = new Date(this.currentMonth.getFullYear(), this.currentMonth.getMonth() - 1);
  }

  nextMont1h(): void {
    this.currentMonth = new Date(this.currentMonth.getFullYear(), this.currentMonth.getMonth() + 1);
  }

  isPastDate(date: Date): boolean {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const checkDate = new Date(date);
    checkDate.setHours(0, 0, 0, 0);
    return checkDate < today;
  }

  // startDateSelection1(event: MouseEvent, date: Date): void {
  //   event.preventDefault();
  //   this.isSelecting = true;
  //   this.selectionStart = date;
  //   this.tempDateRange = [date];
  // }

  // onDateHover1(date: Date): void {
  //   if (this.isSelecting && this.selectionStart) {
  //     const start = this.selectionStart < date ? this.selectionStart : date;
  //     const end = this.selectionStart < date ? date : this.selectionStart;
  //     this.tempDateRange = this.getDateRange(start, end);
  //   }
  // }

  endDateSelection1(date: Date): void {
    if (this.isSelecting && this.selectionStart) {
      this.isSelecting = false;
      this.showTimeModal = true;
    }
  }

  getDateRange(start: Date, end: Date): Date[] {
    const dates = [];
    const current = new Date(start);
    while (current <= end) {
      dates.push(new Date(current));
      current.setDate(current.getDate() + 1);
    }
    return dates;
  }

  // isDateSelected1(date: Date): boolean {
  //   //return true;
  //   return this.tempDateRange.some(d => this.isSameDay(d, date));
  // }

  isDateInRange1(date: Date): boolean {
    const ranges = this.getCurrentTabDateRanges();
    return ranges.some(range => {
      return date >= range.StartDate && date <= range.EndDate;
    });
    // return true;
  }

  isRangeStart1(date: Date): boolean {
    const ranges = this.getCurrentTabDateRanges();
    return ranges.some(range => this.isSameDay(range.StartDate, date));
    // return true;
  }

  isRangeEnd1(date: Date): boolean {
    const ranges = this.getCurrentTabDateRanges();
    return ranges.some(range => this.isSameDay(range.EndDate, date));
    //return true;
  }

  isSameDay(date1: Date, date2: Date): boolean {

    if (!date1 || !date2) return false;
    return date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate();
    //  return true;
  }

  // saveTimeSelection1(): void {
  //   if (this.tempDateRange.length > 0) {
  //     const newRange: DateRange = {
  //       Id: Date.now().toString(),
  //       StartDate: this.tempDateRange[0],
  //       EndDate: this.tempDateRange[this.tempDateRange.length - 1],
  //       StartTime: this.tempStartTime,
  //       EndTime: this.tempEndTime,
  //       Title: this.tempTitle
  //     };

  //     const currentSchedule = this.schedules.at(this.activeTabIndex);
  //     const currentRanges = currentSchedule.get('dateRanges')?.value || [];
  //     currentSchedule.patchValue({
  //       dateRanges: [...currentRanges, newRange]
  //     });
  //   }
  //   this.closeTimeModal();
  // }

  closeTimeModal(): void {
    this.showTimeModal = false;
    // this.tempDateRange = [];
    this.selectionStart = null;
    this.tempStartTime = '09:00';
    this.tempEndTime = '17:00';
    this.tempTitle = '';
    this.tempDateRange = null;
  }

  getCurrentTabDateRanges1(): DateRange[] {
    const currentSchedule = this.schedules.at(this.activeTabIndex);
    return currentSchedule?.get('dateRanges')?.value || [];
  }

  removeRange12(rangeId: string): void {
    const currentSchedule = this.schedules.at(this.activeTabIndex);
    const currentRanges = currentSchedule.get('dateRanges')?.value || [];
    const filteredRanges = currentRanges.filter((r: DateRange) => r.Id !== rangeId);
    currentSchedule.patchValue({ dateRanges: filteredRanges });
  }

  clearAllSchedules1(): void {
    const currentSchedule = this.schedules.at(this.activeTabIndex);
    currentSchedule.patchValue({ dateRanges: [] });
  }

  exportSchedules(): void {
    const ranges = this.getCurrentTabDateRanges();
    this.logger.d('Exporting schedules:', ranges);
    // Implement export logic
  }

  togglePanel1(): void {
    const currentSchedule = this.schedules.at(this.activeTabIndex);
    const currentState = currentSchedule.get('isPanelOpen')?.value;
    currentSchedule.patchValue({ isPanelOpen: !currentState });
  }

  getCurrentTabPanelState1(): boolean {
    const currentSchedule = this.schedules.at(this.activeTabIndex);
    return currentSchedule?.get('isPanelOpen')?.value || false;
  }

  // Participants management
  addParticipant(scheduleIndex: number, input: HTMLInputElement): void {
    const email = input.value.trim();
    if (email) {
      const schedule = this.schedules.at(scheduleIndex);
      const participants = schedule.get('participants')?.value || [];
      if (!participants.includes(email)) {
        schedule.patchValue({ participants: [...participants, email] });
      }
      input.value = '';
    }
  }

  removeParticipantChip(scheduleIndex: number, email: string): void {
    const schedule = this.schedules.at(scheduleIndex);
    const participants = schedule.get('participants')?.value || [];
    schedule.patchValue({
      participants: participants.filter((p: string) => p !== email)
    });
  }

  getParticipantsArray(scheduleIndex: number): string[] {
    return this.schedules.at(scheduleIndex).get('participants')?.value || [];
  }

  // Customer management
  updateCustomerSelections(event: any): void {
    const customerId = event.value;
    const customer = this.customers.find(c => c.id === customerId);
    if (customer) {
      this.logger.d('Selected customer:', customer);
      this.requisitionForm.get('customerDetails')?.patchValue({
        // name: customer.name,
        customerGstNumber: customer.gstNumber,
        contactPersonName: customer.contactPerson.name,
        contactPersonNumber: customer.contactPerson.mobile,
        contactPersonEmail: customer.contactPerson.email,
        customerAddress: customer.address
      });
    }
  }

  // Navigation
  goToStep(step: number): void {
    this.currentStep = step;
  }

  nextStep(): void {
    if (this.currentStep < 3) {
      this.currentStep++;
    }
  }

  previousStep(): void {
    if (this.currentStep > 1) {
      this.currentStep--;
    }
  }

  // Save and Close
  onSave(): void {
    if (this.requisitionForm.valid) {
      const formValue = this.requisitionForm.getRawValue();
      this.logger.d('Form Value on Save:', formValue);
      const userId = localStorage.getItem('userId') || '';
      const convertedData = this.transformEditToExisting(formValue, userId);

      this.logger.d('Transformed Data for Submission[Converted Data]:', convertedData);
      const data: any = {
        RequisitionData: convertedData.Data["RequisitionData"],
        TrainingSchedulesData: convertedData.Data["TrainingSchedulesData"],
        AdditionalInformationData: convertedData.Data["AdditionalInformationData"]
      };
      const storedUser: string | null = localStorage.getItem('userId');
      const obj = {

        CreatedBy: storedUser,
        UpdatedBy: storedUser,
        CreatedOn: new Date(),
        UpdatedOn: new Date(),
        Id: this.requisitionId,
        Data: data

      }

      this.logger.d('Converted Data:', convertedData);

      this.logger.d('Object to be sent to API for save EDIT:', obj);
      this.requisitionService.replaceRequisition(obj).subscribe({
        next: (res: any) => {
          if (res) {
            this.notification.notify("Successfully Updated", "success", 3000);
            this.saved.emit(formValue);
          } else {
            // Handle unexpected response
            this.notification.notify("Failed to update requisition", "error", 3000);
            return;
          }
        },
        error: (err: any) => {
          // Handle HTTP or server error
          this.logger.e("Error updating requisition:", err);
          this.notification.notify("Error occurred while updating requisition" + err, "error", 3000);
          return;
        }
      });
    }
  }

  onClose(): void {
    this.closePopup.emit();
  }

  onSliderChange(event: any): void {
    this.logger.d('Slider changed:', event.target.checked);
  }

  onEnquiryIdBlur(): void {
    // Implement enquiry validation logic
  }

  transformEditToExisting1(editObj: any, currentUserId = "system") {
    const now = new Date().toISOString();

    return {
      id: this.requisitionId || '',
      Data: {
        RequisitionData: {
          name: this.oldRequisitionData.data.RequisitionData.name,
          docId: this.oldRequisitionData.data.RequisitionData.docId,
          docNo: this.oldRequisitionData.data.RequisitionData.docNo,
          docDate: editObj.requisition.docDate,
          customerDetails: {
            id: editObj.customerDetails.customerId,
            name: this.customers.find(customer => customer.id == editObj.customerDetails.customerId).name, // can fetch dynamically if needed
            isActive: true,
            createdBy: currentUserId,
            createdOn: now,
            updatedOn: now,
            updatedBy: currentUserId,
            address: editObj.customerDetails.customerAddress,
            website: "",
            gstNumber: editObj.customerDetails.customerGstNumber,
            contactPerson: {
              id: "",
              name: editObj.customerDetails.contactPersonName,
              isActive: true,
              createdBy: currentUserId,
              createdOn: now,
              updatedOn: now,
              updatedBy: currentUserId,
              email: editObj.customerDetails.contactPersonEmail,
              mobile: { $numberLong: editObj.customerDetails.contactPersonNumber.toString() }
            },
            customerType: editObj.customerDetails.customerType
          },
          status: this.oldRequisitionData.data.RequisitionData.status,
          enquiryId: editObj.requisition.enquiryId,
          requisitionType: this.oldRequisitionData.data.RequisitionData.requisitionType,
          paymentTerms: ""
        },

        TrainingSchedulesData: editObj.trainingSchedules.map((sch: { title: any; courseId: any; participants: any; trainers: any; dateRanges: any[]; accessViaInvitedEmailOnly: any; trainingDetail: any; }) => ({
          Title: sch.title,
          Course: {
            Code: "Custom",
            Provider: "",
            Description: "",
            VmImage: {},
            Labs: [],
            ShowMenu: false,
            Id: sch.courseId || "-1",
            Name: "Custom Course",
            IsActive: true,
            CreatedBy: currentUserId,
            CreatedOn: now,
            UpdatedOn: now,
            UpdatedBy: currentUserId,
            EntityType: "CourseEntity"
          },
          Participants: sch.participants,
          Trainers: [
            {
              Id: sch.trainers,
              Name: this.trainers.find(tr => tr.id === sch.trainers)?.name || 'Unknown'
            }
          ],

          DateRanges: sch.dateRanges.map(dr => ({
            StartDate: dr.startDate,
            EndDate: dr.endDate,
            StartTime: dr.startTime,
            EndTime: dr.endTime
          })),
          // DateRanges: this.tabCalendarStates[schedIndex]?.dateRanges?.map(dr => ({
          //   Id: dr.Id,
          //   Title: dr.Title,
          //   StartDate: dr.StartDate,
          //   EndDate: dr.EndDate,
          //   StartTime: dr.StartTime,
          //   EndTime: dr.EndTime
          // })) || []

          TrainersRemarks: "",
          AccessViaInvitedEmailOnly: sch.accessViaInvitedEmailOnly,
          TrainingDetail: sch.trainingDetail,
          RemovalOption: "",
          RemovalDateTime: "",
          ResourceTemplateIds: [],
          Id: crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}`, // generate new ID
          Name: "",
          IsActive: true,
          CreatedBy: currentUserId,
          CreatedOn: now,
          UpdatedOn: now,
          UpdatedBy: currentUserId,
          EntityType: "TrainingSchedulesData"
        })),

        AdditionalInformationData: {
          name: "Additional Information",
          specialRequirements: editObj.additionalInfo.specialRequirements,
          finalComments: editObj.additionalInfo.finalComments
        },

        RequisitionMovement: {
          CurrentStage: editObj.requisition.status,
          RequisitionMovementId: ""
        }
      },

      Id: "",
      Name: "",
      IsActive: true,
      CreatedBy: currentUserId,
      CreatedOn: now,
      UpdatedOn: now,
      UpdatedBy: currentUserId,
      EntityType: "RequisitionModel"
    };
  }

  // Replace the calendar initialization in ngOnInit
  ngOnInit(): void {
    this.initializeForm();
    this.createForm();
    this.loadCourse();
    this.loadCustomers();
    this.userGetByRole('trainer');

    // Initialize calendar state for first tab
    this.initializeTabCalendarState(0);
    this.setupMouseEvents();

    if (this.requisitionId) {
      this.loadRequisitionData();
    }
  }

  // Add these new methods
  private initializeTabCalendarState(tabIndex: number): void {
    if (!this.tabCalendarStates[tabIndex]) {
      this.tabCalendarStates[tabIndex] = {
        currentDate: new Date(),
        calendarDates: [],
        dateRanges: [],
        isPanelOpen: false,
        isSelecting: false,
        selectionStart: null,
        selectionEnd: null,
        currentHoverDate: null
      };
      this.generateCalendarDatesForTab(tabIndex);
    }
  }

  private generateCalendarDatesForTab(tabIndex: number): void {
    const state = this.tabCalendarStates[tabIndex];
    if (!state) return;

    const year = state.currentDate.getFullYear();
    const month = state.currentDate.getMonth();

    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const startDate = new Date(firstDay);
    startDate.setDate(startDate.getDate() - firstDay.getDay());

    state.calendarDates = [];
    const currentCalendarDate = new Date(startDate);

    for (let i = 0; i < 42; i++) {
      state.calendarDates.push({
        date: new Date(currentCalendarDate),
        isCurrentMonth: currentCalendarDate.getMonth() === month
      });
      currentCalendarDate.setDate(currentCalendarDate.getDate() + 1);
    }
  }

  setupMouseEvents(): void {
    document.addEventListener('mouseup', () => {
      Object.values(this.tabCalendarStates).forEach(state => {
        if (state.isSelecting) {
          state.isSelecting = false;
        }
      });
    });
  }

  // Replace existing calendar methods
  getCurrentTabCalendarDates(): any[] {
    const state = this.tabCalendarStates[this.activeTabIndex];
    return state ? state.calendarDates : [];
  }

  getMonthYear(): string {
    const state = this.tabCalendarStates[this.activeTabIndex];
    return state ? state.currentDate.toLocaleString('default', { month: 'long', year: 'numeric' }) : '';
  }

  previousMonth(): void {
    const state = this.tabCalendarStates[this.activeTabIndex];
    if (state) {
      state.currentDate.setMonth(state.currentDate.getMonth() - 1);
      this.generateCalendarDatesForTab(this.activeTabIndex);
    }
  }

  nextMonth(): void {
    const state = this.tabCalendarStates[this.activeTabIndex];
    if (state) {
      state.currentDate.setMonth(state.currentDate.getMonth() + 1);
      this.generateCalendarDatesForTab(this.activeTabIndex);
    }
  }

  startDateSelection(event: MouseEvent, date: Date): void {
    event.preventDefault();
    const state = this.tabCalendarStates[this.activeTabIndex];
    if (state) {
      state.isSelecting = true;
      state.selectionStart = new Date(date);
      state.selectionEnd = new Date(date);
      state.currentHoverDate = new Date(date);
    }
  }

  onDateHover1(date: Date): void {
    const state = this.tabCalendarStates[this.activeTabIndex];
    if (state && state.isSelecting && state.selectionStart) {
      state.currentHoverDate = new Date(date);
      state.selectionEnd = new Date(date);
    }
  }

  endDateSelection(date: Date): void {
    const state = this.tabCalendarStates[this.activeTabIndex];
    if (state && state.isSelecting && state.selectionStart) {
      state.selectionEnd = new Date(date);

      const startDate = state.selectionStart <= state.selectionEnd ? state.selectionStart : state.selectionEnd;
      const endDate = state.selectionStart <= state.selectionEnd ? state.selectionEnd : state.selectionStart;

      this.tempDateRange = { start: startDate, end: endDate };
      this.showTimeModal = true;
      this.tempTitle = '';
      this.editingRange = null;
      this.editingTabIndex = this.activeTabIndex;
    }
    if (state) {
      state.isSelecting = false;
    }
  }

  isDateSelected(date: Date): boolean {
    const state = this.tabCalendarStates[this.activeTabIndex];
    return state ? state.dateRanges.some(range =>
      date >= range.StartDate && date <= range.EndDate
    ) : false;
  }

  isDateInRange(date: Date): boolean {
    const state = this.tabCalendarStates[this.activeTabIndex];
    if (!state || !state.isSelecting || !state.selectionStart || !state.currentHoverDate) {
      return false;
    }

    const start = state.selectionStart <= state.currentHoverDate ? state.selectionStart : state.currentHoverDate;
    const end = state.selectionStart <= state.currentHoverDate ? state.currentHoverDate : state.selectionStart;

    return date > start && date < end;
  }

  isRangeStart(date: Date): boolean {
    const state = this.tabCalendarStates[this.activeTabIndex];
    if (state && state.isSelecting && state.selectionStart && state.currentHoverDate) {
      const start = state.selectionStart <= state.currentHoverDate ? state.selectionStart : state.currentHoverDate;
      return this.isSameDay(date, start);
    }
    return state ? state.dateRanges.some(range => this.isSameDay(date, range.StartDate)) : false;
  }

  isRangeEnd(date: Date): boolean {
    const state = this.tabCalendarStates[this.activeTabIndex];
    if (state && state.isSelecting && state.selectionStart && state.currentHoverDate) {
      const end = state.selectionStart <= state.currentHoverDate ? state.currentHoverDate : state.selectionStart;
      return this.isSameDay(date, end);
    }
    return state ? state.dateRanges.some(range => this.isSameDay(date, range.EndDate)) : false;
  }

  // Replace saveTimeSelection
  saveTimeSelection1(): void {
    this.logger.i('form values', this.timeSelectionForm.value);
    this.tempStartTime = this.timeSelectionForm.get('startTime')?.value;
    this.tempEndTime = this.timeSelectionForm.get('endTime')?.value;
    this.tempTitle = this.timeSelectionForm.get('trainingTitle')?.value;

    if (this.tempDateRange && this.tempStartTime && this.tempEndTime) {
      if (this.tempStartTime >= this.tempEndTime) {
        alert('End time must be after start time');
        return;
      }

      const state = this.tabCalendarStates[this.editingTabIndex];
      if (!state) return;

      if (this.editingRange) {
        this.editingRange.StartDate = this.tempDateRange.start;
        this.editingRange.EndDate = this.tempDateRange.end;
        this.editingRange.StartTime = this.tempStartTime;
        this.editingRange.EndTime = this.tempEndTime;
        this.editingRange.Title = this.tempTitle || this.editingRange.Title;
      } else {
        const newRange: DateRange = {
          Id: Date.now().toString(),
          Title: this.tempTitle,
          StartDate: this.tempDateRange.start,
          EndDate: this.tempDateRange.end,
          StartTime: this.tempStartTime,
          EndTime: this.tempEndTime
        };
        state.dateRanges.push(newRange);
      }

      this.closeTimeModal();
      this.logger.i('Date range saved for tab', this.editingTabIndex, ':', state.dateRanges);
    }
  }

  // Replace getCurrentTabDateRanges
  getCurrentTabDateRanges(): DateRange[] {
    const state = this.tabCalendarStates[this.activeTabIndex];
    return state ? state.dateRanges : [];
  }

  // Replace removeRange
  removeRange1(rangeId: string): void {
    const state = this.tabCalendarStates[this.activeTabIndex];
    if (state) {
      state.dateRanges = state.dateRanges.filter(range => range.Id !== rangeId);
    }
  }

  // Replace togglePanel
  togglePanel(): void {
    const state = this.tabCalendarStates[this.activeTabIndex];
    if (state) {
      state.isPanelOpen = !state.isPanelOpen;
    }
  }

  // Replace getCurrentTabPanelState
  getCurrentTabPanelState(): boolean {
    const state = this.tabCalendarStates[this.activeTabIndex];
    return state ? state.isPanelOpen : false;
  }

  // Replace clearAllSchedules
  clearAllSchedules12(): void {
    const state = this.tabCalendarStates[this.activeTabIndex];
    if (state && confirm('Are you sure you want to clear all training schedules for this tab?')) {
      state.dateRanges = [];
    }
  }

  // Update addSchedule
  addSchedule(): void {
    this.schedules.push(this.createScheduleGroup());
    const newIndex = this.schedules.length - 1;
    this.activeTabIndex = newIndex;
    this.initializeTabCalendarState(newIndex);
  }

  // Update setActiveTab
  setActiveTab(index: number): void {
    this.activeTabIndex = index;
    this.initializeTabCalendarState(index);
  }

  // Update populateFormTrainingScheduleData to include calendar state
  populateFormTrainingScheduleData(data: TrainingSchedule_Data[]): void {
    const schedulesArray = this.requisitionForm.get('trainingSchedules') as FormArray;
    schedulesArray.clear();

    if (!data || data.length === 0) {
      this.logger.w('No trainingSchedulesData found');
      return;
    }

    data.forEach((schedule, index) => {
      const dateRangesArray = this.fb.array(
        (schedule.DateRanges || []).map(range =>
          this.fb.group({
            id: [range.Id || Date.now().toString()],
            title: [range.Title || ''],
            startDate: [new Date(range.StartDate)],
            endDate: [new Date(range.EndDate)],
            startTime: [range.StartTime],
            endTime: [range.EndTime]
          })
        )
      );



      const scheduleGroup = this.fb.group({
        title: [schedule.Title || ''],
        courseId: [schedule.Course?.Id || ''],
        participants: [schedule.Participants || []],
        accessViaInvitedEmailOnly: [schedule.AccessViaInvitedEmailOnly || false],
        trainers: [schedule.Trainers[0]?.Id || ''],
        trainingDetail: [schedule.TrainingDetail || ''],
        dateRanges: dateRangesArray,
        isPanelOpen: [false]
      });

      schedulesArray.push(scheduleGroup);

      // Initialize calendar state with existing date ranges
      this.tabCalendarStates[index] = {
        currentDate: new Date(),
        calendarDates: [],
        dateRanges: (schedule.DateRanges || []).map(range => ({
          Id: range.Id || Date.now().toString(),
          Title: range.Title || '',
          StartDate: new Date(range.StartDate),
          EndDate: new Date(range.EndDate),
          StartTime: range.StartTime,
          EndTime: range.EndTime
        })),
        isPanelOpen: false,
        isSelecting: false,
        selectionStart: null,
        selectionEnd: null,
        currentHoverDate: null
      };
      this.generateCalendarDatesForTab(index);
    });
  }


  saveTimeSelection(): void {
    this.logger.i('form values', this.timeSelectionForm.value);
    this.tempStartTime = this.timeSelectionForm.get('startTime')?.value;
    this.tempEndTime = this.timeSelectionForm.get('endTime')?.value;
    this.tempTitle = this.timeSelectionForm.get('trainingTitle')?.value;

    if (this.tempDateRange && this.tempStartTime && this.tempEndTime) {
      if (this.tempStartTime >= this.tempEndTime) {
        alert('End time must be after start time');
        return;
      }

      const state = this.tabCalendarStates[this.editingTabIndex];
      if (!state) return;

      if (this.editingRange) {
        // Update existing range
        this.editingRange.StartDate = this.tempDateRange.start;
        this.editingRange.EndDate = this.tempDateRange.end;
        this.editingRange.StartTime = this.tempStartTime;
        this.editingRange.EndTime = this.tempEndTime;
        this.editingRange.Title = this.tempTitle || this.editingRange.Title;
      } else {
        // Create new range
        const newRange: DateRange = {
          Id: Date.now().toString(),
          Title: this.tempTitle,
          StartDate: this.tempDateRange.start,
          EndDate: this.tempDateRange.end,
          StartTime: this.tempStartTime,
          EndTime: this.tempEndTime
        };
        state.dateRanges.push(newRange);
      }

      // CRITICAL: Sync form array with calendar state
      this.syncDateRangesToForm(this.editingTabIndex);

      this.closeTimeModal();
      this.logger.i('Date range saved for tab', this.editingTabIndex, ':', state.dateRanges);
    }
  }


  // 2. Add this new method to sync calendar state to form
  private syncDateRangesToForm(tabIndex: number): void {
    const state = this.tabCalendarStates[tabIndex];
    if (!state) return;

    const schedule = this.schedules.at(tabIndex) as FormGroup;
    const dateRangesArray = this.fb.array(
      state.dateRanges.map(range =>
        this.fb.group({
          id: [range.Id],
          title: [range.Title],
          startDate: [range.StartDate],
          endDate: [range.EndDate],
          startTime: [range.StartTime],
          endTime: [range.EndTime]
        })
      )
    );

    schedule.setControl('dateRanges', dateRangesArray);
  }



  // 3. Replace removeRange to sync with form
  removeRange(rangeId: string): void {
    const state = this.tabCalendarStates[this.activeTabIndex];
    if (state) {
      state.dateRanges = state.dateRanges.filter(range => range.Id !== rangeId);
      // Sync to form
      this.syncDateRangesToForm(this.activeTabIndex);
    }
  }

  // 4. Replace clearAllSchedules to sync with form
  clearAllSchedules(): void {
    const state = this.tabCalendarStates[this.activeTabIndex];
    if (state && confirm('Are you sure you want to clear all training schedules for this tab?')) {
      state.dateRanges = [];
      // Sync to form
      this.syncDateRangesToForm(this.activeTabIndex);
    }
  }


  /**
   * Serialises a Date (or bare YYYY-MM-DD string) to a YYYY-MM-DD string using LOCAL
   * calendar date parts, so the backend receives the exact day the user picked regardless
   * of timezone. Sending a raw Date object here would get JSON-serialised via
   * .toISOString() (always UTC) by Angular's HttpClient, which shifts any UTC+ timezone
   * user's local-midnight pick back to the previous UTC calendar day (e.g. IST midnight
   * becomes 18:30 UTC the day before), causing ClassModel.Status to misclassify the
   * resulting class as OnGoing/Completed a day early.
   */
  private formatLocalDate(d: any): string | null {
    if (!d) return null;
    if (d instanceof Date) {
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${y}-${m}-${day}`;
    }
    return String(d).substring(0, 10) || null;
  }

  // 5. Fix transformEditToExisting to read from tabCalendarStates
  transformEditToExisting(editObj: any, currentUserId = "system") {
    const now = new Date().toISOString();

    return {
      id: this.requisitionId || '',
      Data: {
        RequisitionData: {
          name: this.oldRequisitionData.data.RequisitionData.name,
          docId: this.oldRequisitionData.data.RequisitionData.docId,
          docNo: this.oldRequisitionData.data.RequisitionData.docNo,
          docDate: editObj.requisition.docDate,
          customerDetails: {
            id: editObj.customerDetails.customerId,
            name: this.customers.find(customer => customer.id == editObj.customerDetails.customerId)?.name || '',
            isActive: true,
            createdBy: currentUserId,
            createdOn: now,
            updatedOn: now,
            updatedBy: currentUserId,
            address: editObj.customerDetails.customerAddress,
            website: "",
            gstNumber: editObj.customerDetails.customerGstNumber,
            contactPerson: {
              id: "",
              name: editObj.customerDetails.contactPersonName,
              isActive: true,
              createdBy: currentUserId,
              createdOn: now,
              updatedOn: now,
              updatedBy: currentUserId,
              email: editObj.customerDetails.contactPersonEmail,
              mobile: { $numberLong: editObj.customerDetails.contactPersonNumber.toString() }
            },
            customerType: editObj.customerDetails.customerType
          },
          status: this.oldRequisitionData.data.RequisitionData.status,
          enquiryId: editObj.requisition.enquiryId,
          requisitionType: this.oldRequisitionData.data.RequisitionData.requisitionType,
          paymentTerms: ""
        },

        TrainingSchedulesData: editObj.trainingSchedules.map((sch: any, schedIndex: number) => {
          // CRITICAL FIX: Read from tabCalendarStates instead of form
          const calendarState = this.tabCalendarStates[schedIndex];

          return {
            Title: sch.title,
            Course: {
              Code: "Custom",
              Provider: "",
              Description: "",
              VmImage: {},
              Labs: [],
              ShowMenu: false,
              Id: sch.courseId || "-1",
              Name: "Custom Course",
              IsActive: true,
              CreatedBy: currentUserId,
              CreatedOn: now,
              UpdatedOn: now,
              UpdatedBy: currentUserId,
              EntityType: "CourseEntity"
            },
            Participants: sch.participants,
            Trainers: [
              {
                Id: sch.trainers,
                Name: this.trainers.find(tr => tr.id === sch.trainers)?.name || 'Unknown'
              }
            ],
            // FIX: Use calendar state for date ranges
            DateRanges: calendarState?.dateRanges?.map(dr => ({
              Id: dr.Id,
              Title: dr.Title,
              StartDate: this.formatLocalDate(dr.StartDate),
              EndDate: this.formatLocalDate(dr.EndDate),
              StartTime: dr.StartTime,
              EndTime: dr.EndTime
            })) || [],
            TrainersRemarks: "",
            AccessViaInvitedEmailOnly: sch.accessViaInvitedEmailOnly,
            TrainingDetail: sch.trainingDetail,
            RemovalOption: "",
            RemovalDateTime: "",
            ResourceTemplateIds: [],
            Id: crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}`,
            Name: "",
            IsActive: true,
            CreatedBy: currentUserId,
            CreatedOn: now,
            UpdatedOn: now,
            UpdatedBy: currentUserId,
            EntityType: "TrainingSchedulesData"
          };
        }),

        AdditionalInformationData: {
          name: "Additional Information",
          specialRequirements: editObj.additionalInfo.specialRequirements,
          finalComments: editObj.additionalInfo.finalComments
        },

        RequisitionMovement: {
          CurrentStage: editObj.requisition.status,
          RequisitionMovementId: ""
        }
      },

      Id: "",
      Name: "",
      IsActive: true,
      CreatedBy: currentUserId,
      CreatedOn: now,
      UpdatedOn: now,
      UpdatedBy: currentUserId,
      EntityType: "RequisitionModel"
    };
  }

  // 6. Update populateFormTrainingScheduleData to ensure proper Date conversion
  populateFormTrainingScheduleData12(data: TrainingSchedule_Data[]): void {
    const schedulesArray = this.requisitionForm.get('trainingSchedules') as FormArray;
    schedulesArray.clear();

    if (!data || data.length === 0) {
      this.logger.w('No trainingSchedulesData found');
      return;
    }

    data.forEach((schedule, index) => {
      const scheduleGroup = this.fb.group({
        title: [schedule.Title || ''],
        courseId: [schedule.Course?.Id || ''],
        participants: [schedule.Participants || []],
        accessViaInvitedEmailOnly: [schedule.AccessViaInvitedEmailOnly || false],
        trainers: [schedule.Trainers[0]?.Id || ''],
        trainingDetail: [schedule.TrainingDetail || ''],
        dateRanges: this.fb.array([]), // Will be synced from calendar state
        isPanelOpen: [false]
      });

      schedulesArray.push(scheduleGroup);

      // Initialize calendar state with existing date ranges
      this.tabCalendarStates[index] = {
        currentDate: new Date(),
        calendarDates: [],
        dateRanges: (schedule.DateRanges || []).map(range => ({
          Id: range.Id || Date.now().toString(),
          Title: range.Title || '',
          StartDate: new Date(range.StartDate),
          EndDate: new Date(range.EndDate),
          StartTime: range.StartTime,
          EndTime: range.EndTime
        })),
        isPanelOpen: false,
        isSelecting: false,
        selectionStart: null,
        selectionEnd: null,
        currentHoverDate: null
      };

      this.generateCalendarDatesForTab(index);

      // Sync calendar state to form
      this.syncDateRangesToForm(index);
    });
  }




  // STEP 3B: Add month change scheduling properties (add to component class)
  private monthChangeTimeout: any = null;
  private monthChangeDirection: 'next' | 'prev' | null = null;

  // STEP 3C: Replace onDateHover method with auto-navigation
  onDateHover(date: Date): void {
    const state = this.tabCalendarStates[this.activeTabIndex];
    if (state && state.isSelecting && state.selectionStart) {
      const calendarDates = state.calendarDates;
      const index = calendarDates.findIndex(d => this.isSameDay(d.date, date));

      const totalRows = 6; // 42 days
      const rowIndex = Math.floor(index / 7);
      const colIndex = index % 7; // 0 = Sunday, 6 = Saturday

      const canGoPrev = this.canNavigateMonth('prev');
      const canGoNext = this.canNavigateMonth('next');

      // Horizontal + Vertical detection with date guard
      if ((rowIndex <= 0 || colIndex === 0) && canGoPrev) {
        this.scheduleMonthChange('prev');
      }
      else if ((rowIndex >= totalRows - 1 || colIndex === 6) && canGoNext) {
        this.scheduleMonthChange('next');
      }
      else {
        this.cancelMonthChange();
      }

      state.currentHoverDate = new Date(date);
      state.selectionEnd = new Date(date);
    }
  }

  // STEP 3D: Add canNavigateMonth method
  private canNavigateMonth(direction: 'prev' | 'next'): boolean {
    const state = this.tabCalendarStates[this.activeTabIndex];
    if (!state) return false;

    const newDate = new Date(state.currentDate);
    if (direction === 'prev') {
      newDate.setMonth(newDate.getMonth() - 1);
    } else {
      newDate.setMonth(newDate.getMonth() + 1);
    }

    // Check if the target month has at least one selectable date
    const year = newDate.getFullYear();
    const month = newDate.getMonth();
    const daysInMonth = new Date(year, month + 1, 0).getDate();

    for (let day = 1; day <= daysInMonth; day++) {
      const testDate = new Date(year, month, day);
      if (!this.isPastDate(testDate)) {
        return true; // found a selectable date
      }
    }
    return false; // all past dates, don't navigate
  }

  // STEP 3E: Add scheduleMonthChange method
  private scheduleMonthChange(direction: 'next' | 'prev') {
    if (this.monthChangeDirection !== direction) {
      this.cancelMonthChange(); // Reset any previous timer
      this.monthChangeDirection = direction;
      this.monthChangeTimeout = setTimeout(() => {
        if (direction === 'next') this.nextMonth();
        else this.previousMonth();
        this.monthChangeDirection = null;
      }, 400); // delay 0.4 sec before changing month
    }
  }

  // STEP 3F: Add cancelMonthChange method
  private cancelMonthChange() {
    if (this.monthChangeTimeout) {
      clearTimeout(this.monthChangeTimeout);
      this.monthChangeTimeout = null;
    }
    this.monthChangeDirection = null;
  }
}



